module.exports = __webpack_public_path__ + "static/gallery5-e939f6491798ed62385c3eb37eecf55a.jpg";